import { AccountRecoveryRequest } from "app/services/api/types/authorisation/requests/AccountRecoveryRequest";
import { Link } from "expo-router";
import { Text } from "react-native";
import { AtomsView } from "ui";
import { Button } from "ui/gluestack/button";
import { FormControlledInput } from "ui/molecules/form/FormControlledInput";
import {
  emailValidation,
  maxLengthValidation,
  minLengthValidation,
  requiredValidation,
  validationSchema,
} from "ui/utils/Validators";
import { useAccountRecovery } from "../hooks/useAccountRecovery";
import { LoginPath } from "app/constants/routePaths";
import Card from "../atoms/Card";
import { CardLogo } from "../atoms/CardLogo";

interface Props {
  onRecoverySent?: () => void;
}

export default function AccountRecoveryForm({ onRecoverySent }: Props) {
  const { control, submitForm, isLoading } = useAccountRecovery(onRecoverySent);

  return (
    <AtomsView className="flex-1 justify-center items-center w-full bg-white">
      <Card>
        <CardLogo />

        <Text className="font-semibold text-xl">Forgot password?</Text>
        <Text className="text-typography-800 text-sm">
          Don’t worry! Fill in your email and we’ll send you a link to reset
          your password
        </Text>
        <FormControlledInput<AccountRecoveryRequest>
          id="recovery-email"
          name="email"
          control={control}
          label={"Email"}
          placeholder={"Enter your email"}
          isRequired
          isDisabled={isLoading}
          rules={{
            maxLength: maxLengthValidation(validationSchema.email.maxLength),
            minLength: minLengthValidation(validationSchema.email.minLength),
            required: requiredValidation("Email"),
            validate: {
              emailValidation,
            },
          }}
          onSubmitEditing={submitForm}
        />
        <Button onPress={submitForm} action="primary" isDisabled={isLoading}>
          <Text className="text-white">Send Email</Text>
        </Button>
        <Link className="self-center h-8 justify-center" href={LoginPath}>
          <Text className="text-typography-500 hover:underline">
            Back to Log in
          </Text>
        </Link>
      </Card>
    </AtomsView>
  );
}
